import Base from "./Base";
import store from "../storeWire";
import {
    SET_SHIPPING_ADDRESS_LIST
} from "../store/slice/auth";

class Auth extends Base {
    SHIPPING_ADDRESS_LIST = {};

    setShippingAddressList(data) {
        this.SHIPPING_ADDRESS_LIST = data.SHIPPING_ADDRESS_LIST;
        store.dispatch(SET_SHIPPING_ADDRESS_LIST({
            SHIPPING_ADDRESS_LIST: this.SHIPPING_ADDRESS_LIST
        }));
    }
}

export default Auth;